<template>
	<div class="wrapper">
		<div class="qrCode-wrapper">
			<p>停车券密码：{{couponKey}}</p>
			<vue-qr :text="url" :margin="0" :size="250">
			</vue-qr>
		</div>
		<div class="weui-cells weui-cells_checkbox">
			<label class="weui-cell weui-check__label">
				<div class="weui-cell__hd" @change="handleChange">
					<input type="checkbox" class="weui-check" v-model="isChecked" name="checkbox1">
					<i class="weui-icon-checked"></i>
				</div>
				<div class="weui-cell__bd">
					<p>需要用户绑定车牌</p>
				</div>
			</label>
		</div>
		<article class="weui-article">
			<section>
				<p>勾选“需要用户绑定车牌”选项后，非绑定的车牌不可使用停车券。</p>
				<p>注：当前密码及二维码只可以使用一次，绑定后失效。若要继续发放，请返回上一页面重新点击发放后进入该页面，密码及二维码会重新生成。</p>
			</section>
		</article>
	</div>
</template>

<script>
    import { getCouponKey } from "../../../api/coupon/rationFee";
    import vueQr from 'vue-qr';
    import { mapGetters } from 'vuex'
    import scan from '../../../api/coupon/scan'
	import encrypt from '../../../utils/encrypt'
    export default {
        name: "index",
        data () {
            return {
                url: undefined,
                isChecked: true,
                couponKey: undefined
            }
        },
        components: {
            vueQr
        },
        computed: {
            ...mapGetters(['taskId'])
        },
        created () {
            this.createUrl();
            getCouponKey({taskId: this.taskId}).then(res =>{
                this.couponKey = res.msg
            })
        },
        methods: {
			createUrl () {
                this.url = scan.link + '?taskId=' + encrypt.encrypt(this.taskId) +
                    '&isGZH=' + true + '&isChecked=' + this.isChecked + "&isRationFee=" + true;
			},
            handleChange () {
                this.createUrl()
			}
        }
    }
</script>

<style scoped lang="stylus">
	@import '~common/stylus/variable';
	.qrCode-wrapper{
		padding 20px 0
		display flex
		flex-direction column
		align-items center
		p{
			color #898989
			padding-bottom 20px
		}
	}
	.weui-article{
		padding-top 5px
		p {
			font-size $article-merchant-p
			color $article-p-color
			line-height 20px
		}
	}
</style>
